import output from "_src/engine/output";
import workerPool from "_src/engine/worker_pool";
import { messageType, getWorkerType, resultStatus } from "_src/engine/ipc.js";
import { Transfer } from "threads"

const _workersTaskBoard = {};

let _uniqueID = 0;

export default {

  INVALID_ID : -1,

  _queue : {},
  _verbose : false,

  _pop : async function(type) {

    const workerType = getWorkerType(type);

    const queue = this._queue[workerType];

    if (queue.length === 0) {
      return;
    }

    const availableWorker = workerPool.getWorker(type);
    if (!availableWorker) {
      setTimeout(() => {this._pop(type)}, 1000);
      return;
    }

    const worker = await availableWorker.spawnPromise;
    if (!worker) {
      setTimeout(() => {this._pop(type)}, 1000);
      return;
    }

    if (queue.length === 0) {
      return;
    }

    const task = queue.pop();

    const message = task.message;
    const transfer = task.transfer;

    const resolve = task.resolve;
    const reject = task.reject;

    this._setWorkerTask(worker, task);

    const result = await worker.processMessage(Transfer(message, transfer));

    this._onMessage(availableWorker, message.type, result, resolve, reject, task.tid);

  },

  _push : function(task) {

    const type = task.message.type;
    const workerType = getWorkerType(type);

    if (!this._queue[workerType]) {
      this._queue[workerType] = [];
    }

    this._queue[workerType].push(task);

  },

  _setWorkerTask : function(worker, task) {
    _workersTaskBoard[task.tid] = { worker, task };
  },

  _cleanupWorkerTask : function(tid) {
    delete _workersTaskBoard[tid];
  },

  _onMessage : function(workerWrapper, originType, data, resolve, reject, tid) {

    const type = data.type;

    if (type == messageType.ERROR_CODE || type == messageType.TERMINATE) {

      if (reject) {
        reject({ code : data.status, message : data.message });
      }

    } else {

      if (this._verbose) {
        output.log(data.message, output.INDIGO);
      }

      if (resolve) {
        resolve({ type, data });
      }

    }

    workerPool.returnWorker(originType, workerWrapper);

    this._cleanupWorkerTask(tid);

    this._pop(originType);

  },

  sendMessage : function(message, transfer = [], tid) {

    return new Promise((resolve, reject) => {

      const task = {
        message : message,
        transfer : transfer,
        resolve : resolve,
        reject : reject,
        tid : tid
      };

      const type = message.type;

      this._push(task);
      this._pop(type);

    });

  },

  terminateByType(workerType) {

    const queue = this._queue[workerType]
    if (queue) {
      for (const task of queue) {
        this.terminateByID(task.tid);
      }
    }

  },

  terminateByID(tid) {
    for (const type in this._queue) {
      const queue = this._queue[type];
      for (let i = 0; i < queue.length; ++i) {
        if (queue[i].tid === tid) {
          queue[i].reject({ code : resultStatus.TERMINATED, message : "Terminated" });
          queue.splice(i, 1);
          return;
        }
      }
    }
    const work = _workersTaskBoard[tid];
    if (!work) {
      return;
    }
    work.task.reject({ code : resultStatus.TERMINATED, message : "Terminated" });
    const message = {
      type : messageType.TERMINATE
    };
    work.worker.processMessage(Transfer(message, []));
    this._cleanupWorkerTask(tid);
  },

  checkWorkersSupport() {
    if (typeof window !== "undefined") {
      return typeof window.Worker !== "undefined"
    }
    // NOTE: we consider worker-threads to be supported in nodejs. Node >= v10.5.0 is required
    return true;
  },

  generateUniqueID() {
    return ++_uniqueID;
  }

}
